import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"
import apiPath from "../../shared/apiPath"
// -- import * as _ from "lodash-es"

const content_type = ""

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = [{
  key: "id",
  label: "编号",
  type: "button",
  button: {
    type: "text"
  },
  thStyle: {
    width: "60px"
  }
  // isRowHeader:true,
},
{
  key: "code",
  label: "编码",
  sortable: true,
},
{
  key: "name",
  label: "名称",
  sortable: true
},
{
  key: "description",
  label: "说明",
  sortable: true
},
{
  key: "is_valid",
  label: "启用",
  type: "boolean",
}
]
const fields2 = [{
  key: "id",
  label: "编号"
  // isRowHeader:true,
},
{
  key: "code",
  label: "编码",
  sortable: true
},
{
  key: "category",
  label: "类别",
  sortable: true
},
{
  key: "name",
  label: "名称",
  sortable: true
},
{
  key: "description",
  label: "说明",
  sortable: true
},
{
  key: "is_valid",
  label: "启用",
  type: "boolean"
}
]
const role_users_fileds = [{
  key: "id",
  label: "编号"
},
{
  key: "username",
  label: "名称",
  sortable: true
},

{
  key: "realname",
  label: "真实姓名",
  sortable: true
},
{
  key: "email",
  label: "邮箱",
  sortable: true
},
{
  key: "department",
  label: "部门",
  sortable: true
},
{
  key: "is_valid",
  label: "启用",
  type: "boolean"
},
{
  key: "isDomainUser",
  label: "域用户",
  type: "boolean"
}
]
const _role_users_fileds = [{
  key: "id",
  label: "编号"
},
{
  key: "username",
  label: "名称",
  sortable: true
},

{
  key: "realname",
  label: "真实姓名",
  sortable: true
},
{
  key: "email",
  label: "邮箱",
  sortable: true
},
{
  key: "department",
  label: "部门",
  sortable: true
},
{
  key: "is_valid",
  label: "启用",
  type: "boolean"
},
{
  key: "code",
  label: "角色编码",
},
{
  key: "name",
  label: "角色名称",
},
{
  key: "description",
  label: "角色说明",
},
{
  key: "role_valid",
  label: "角色状态",
  type: "boolean"
},
]
const role_users_export_fileds = [{
  key: "roleId",
  label: "角色Id",
},
{
  key: "role_code",
  label: "角色编码",
},
{
  key: "role_name",
  label: "角色名称",
},
{
  key: "role_description",
  label: "角色说明",
},
{
  key: "role_is_valid",
  label: "角色状态",
  type: "boolean"
},
{
  key: "id",
  label: "权限id",
},
{
  key: "code",
  label: "权限编码",
},
{
  key: "name",
  label: "权限名称",
},
{
  key: "category",
  label: "权限分类",
},
{
  key: "description",
  label: "权限说明",
},
{
  key: "is_valid",
  label: "权限状态",
  type: "boolean"
},
]

const dataForm = {
  id: "",
  code: "",
  name: "",
  description: "",
  is_valid: true
}

///前端验证
const rules = {
  code: [{
    required: true,
    message: "请输入编码",
    trigger: "blur"
  }],
  name: [{
    required: true,
    message: "请输入名称",
    trigger: "change"
  }],
  description: [{
    max: 500,
    message: "超过描述长度",
    trigger: "blur"
  }]
}

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}
const methods = {
  // 同步权限(删除原有权限)
  async syncRolePrivileges(roleIds, privileges) {
    const delete_biz_data = new biz_data_helper.base_entity_helper(
      "delete_role_privileges", {}, {}
    )
    const sync_biz_data = new biz_data_helper.base_entity_helper(
      "sync_role_privileges", {}, {}
    )
    let _actions = []
    _.each(roleIds, t => {
      _actions.push(
        delete_biz_data
          .execAction({
            params: {
              roleId: t,
            },
            fields: []
          })
          .action({})
      )
      _.each(privileges, y => {
        _actions.push(
          sync_biz_data
            .execAction({
              params: {
                roleId: t,
                privilegeId: y
              },
              fields: []
            })
            .action({})
        )
      })
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  async pasteRolePrivileges(roleIds, privileges) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "paste_role_privileges", {}, {}
    )
    let _actions = []
    _.each(roleIds, t => {
      _.each(privileges, y => {
        _actions.push(
          code_biz_data
            .execAction({
              params: {
                roleId: t,
                privilegeId: y
              },
              fields: []
            })
            .action({})
        )
      })
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  async getRoleUsers() {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_role_users_data", {}, {}
    )
    let result = await code_biz_data
      .execAction({
        params: {},
        fields: _.map(_role_users_fileds, "key")
      })
      .run()
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //获取角色
  async GetRoleList() {
    let data = await api.query_async({
      url: apiPath.admin.get_role_list,
      parameters: null,
      method: "get"
    })
    if (data) {
      return data[0].result.data.Result
    }
    return null
  },
  //新增角色
  async AddRole(_data) {
    let _p = new FormData()
    let data = null
    if (_data.id) {
      _p.append("roleId", _data.id)
      _p.append("is_valid", _data.is_valid)
    }
    _p.append("code", _data.code)
    _p.append("name", _data.name)
    _p.append("description", _data.description)
    if (_data.id) {
      data = await api.query_async({
        url: apiPath.admin.update_role,
        parameters: _p,
        method: "post"
      })
    } else {
      data = await api.query_async({
        url: apiPath.admin.add_role,
        parameters: _p,
        method: "post"
      })
    }

    if (data) {
      return {
        success: data[0].result.data.Success,
        id: data[0].result.data.Result
      }
    }
    return {
      success: false,
      id: 0
    }
  },
  //添加角色权限
  async SaveRolePrivileges(roleId, _data) {
    let _add = []
    _.each(_data, t => {
      _add.push(t.id)
    })
    let query_settings = []
    let query_settings1 = []
    let _p = new FormData()
    _p.append("roleId", roleId)
    query_settings.push({
      url: apiPath.admin.CleanRoleOwnPrivileges,
      parameters: _p,
      method: "post"
    })
    let data = await api.query_all_async(query_settings)
    if (data) {
      if (data[0].result.data.Success) {
        for (var i in _add) {
          let _p = new FormData()
          _p.append("roleId", roleId)
          _p.append("privilegeId", _add[i])
          query_settings1.push({
            url: apiPath.admin.add_role_own_privileges,
            parameters: _p,
            method: "post"
          })
        }

        let _data = await api.query_all_async(query_settings1)
        if (_data) {
          return _data[0].result.data.Success
        } else {
          return false
        }
      }
    } else {
      return false
    }

  },
  async deleteP(_dataList, roleId) {
    let _data = _dataList.selected_items
    let _del = []
    _.each(_data, t => {
      _del.push(t.id)
    })
    let query_settings = []
    for (var i in _del) {
      let _p = new FormData()
      _p.append("roleId", roleId)
      _p.append("privilegeId", _del[i])
      query_settings.push({
        url: apiPath.admin.remove_role_own_privileges,
        parameters: _p,
        method: "post"
      })
    }
    let data = await api.query_all_async(query_settings)
    if (data) {
      return data[0].result.data.Success
    } else {
      return false
    }
  },
  //新增或删除角色权限
  async AddORDeleteRoleOwnPrivileges(roleId, hasData, newData) {
    //如果hasData中不包含newData中的权限即为新增
    let _add = [],
      _del = []
    for (var i in newData) {
      if (
        _.findIndex(hasData, {
          id: newData[i].id
        }) < 0
      ) {
        _add.push(newData[i])
      }
    }
    //如果newData中不包含hasData的权限即为删除
    for (var i in hasData) {
      if (
        _.findIndex(newData, {
          id: hasData[i].id
        }) < 0
      ) {
        _del.push(hasData[i])
      }
    }

    let query_settings = []
    for (var i in _add) {
      let _p = new FormData()
      _p.append("roleId", roleId)
      _p.append("privilegeId", _add[i].id)
      query_settings.push({
        url: apiPath.admin.add_role_own_privileges,
        parameters: _p,
        method: "post"
      })
    }
    for (var i in _del) {
      let _p = new FormData()
      _p.append("roleId", roleId)
      _p.append("privilegeId", _del[i].id)
      query_settings.push({
        url: apiPath.admin.remove_role_own_privileges,
        parameters: _p,
        method: "post"
      })
    }
    let data = await api.query_all_async(query_settings)
    if (data) {
      return data[0].result.data.Success
    } else {
      return false
    }
  },
  //更改角色信息
  async UpdateRole(_data) {
    let is_deleted = false
    let datas = _data.selected_items
    switch (_data.state) {
      case "valid":
        //启用
        for (var i in datas) {
          datas[i].is_valid = true
        }
        break
      case "invalid":
        for (var i in datas) {
          datas[i].is_valid = false
        }
        //禁用
        break
      case "deleted":
        //删除
        is_deleted = true
        break
      default:
        break
    }
    let query_settings = []

    if (!is_deleted) {
      // 修改操作
      for (var i in datas) {
        let _p = new FormData()
        _p.append("roleId", datas[i].id)
        _p.append("name", datas[i].name)
        _p.append("description", datas[i].description)
        _p.append("is_valid", datas[i].is_valid)
        query_settings.push({
          url: apiPath.admin.update_role,
          parameters: _p,
          method: "post"
        })
      }
      let data = await api.query_all_async(query_settings)
      if (data) {
        return data[0].result.data.Success
      } else {
        return false
      }
    } else {
      // 删除操作
      for (var i in datas) {
        let _p = new FormData()
        _p.append("roleId", datas[i].id)
        query_settings.push({
          url: apiPath.admin.remove_role,
          parameters: _p,
          method: "post"
        })
      }
      let data = await api.query_all_async(query_settings)
      if (data) {
        return data[0].result.data.Success
      } else {
        return false
      }
    }
  },
  //获取权限
  async GetPrivilege() {
    let data = await api.query_async({
      url: apiPath.admin.get_privilege_list,
      parameters: null,
      method: "get"
    })

    if (data) {
      return data[0].result.data.Result
    }
    return null
  },
  async GetRoleOwnPrivilege(roleId) {
    let data = await api.query_async({
      url: apiPath.admin.get_role_own_privilege_list + roleId,
      parameters: null,
      method: "get"
    })
    if (data) {
      return data[0].result.data.Result
    }
    return null
  },
  async GetRoleUsers(roleId, roleCode) {
    const ec_biz_data = new biz_data_helper.base_entity_helper(
      "get_role_users", {}, {}
    )
    let result = await ec_biz_data
      .execAction({
        params: {
          "roleId": roleId,
          "roleCode": roleCode
        },
        fields: _.map(role_users_fileds, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
// export * from "../../shared/biz_data_helper"
export {
  fields,
  fields2,
  role_users_fileds,
  dataForm,
  rules,
  biz_data,
  methods,
  role_users_export_fileds,
  _role_users_fileds
}
